export default {
  base_url: '',
  routes: {
    api_live_get_user_params: {
      tokens: [['text', '/lives/params-live']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },

    api_get_lives_live_detail: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/live/lives-live']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_post_add_lives_live: {
      tokens: [['text', '/lives/lives-live/add']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_post_edit_lives_live: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/lives/lives-live/edit']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_media_get_contributors: {
      tokens: [['text', '/video/videos/contributors/list']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_dtable_list_dtable_lives_endless: {
      tokens: [['text', '/live/endless']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_dtable_list_dtable_lives_archived: {
      tokens: [['text', '/live/archived']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_dtable_list_dtable_lives_all: {
      tokens: [['text', '/live/all']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_dtable_list_dtable_lives_upcoming: {
      tokens: [['text', '/live/upcoming']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_dtable_list_dtable_lives_trash: {
      tokens: [['text', '/live/trash']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_multi_delete_livess: {
      tokens: [['variable', '/', '\\d+', 'list'], ['text', '/multiDelete/livess']],
      defaults: [],
      requirements: {
        list: '\\d+',
      },
      hosttokens: [],
    },
    api_delete_lives_live: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/lives/delete-lives-live']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_post_disable_live: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/lives/disable']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_post_enable_live: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/lives/enable']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_post_lives_thumb: {
      tokens: [['text', '/lives/lives/upload/thumb']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_post_lives_slide: {
      tokens: [['text', '/lives/lives/upload/slide']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_survey_get_list_surveys: {
      tokens: [['text', '/survey/list-surveys']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_get_lives_by_period: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/live/lives-period']],
      defaults: [],
      requirements: {
        startDate: '\\d+',
        endDate: '\\d+',
      },
      hosttokens: [],
    },
    api_video_get_list_transcoded_videos: {
      tokens: [['text', '/video/list-transcoded-videos_details']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_getInfosDetailLive: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', 'live/info_detail']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_getlink_export: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', 'lives/link_export']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_getSubscriptionUser_list: {
      tokens: [['text', '/subscription_user/users']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_send_invitations_mails: {
      tokens: [['text', 'lives/invitations/mails']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_screen_share: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', 'lives/add-screen-share']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_get_url_download_file: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', 'lives/get-url-jnlp-file']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_get_link_video_live: {
      tokens: [['variable', '/', '[^/]++', 'id'], ['text', '/lives/get-link-video-live']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_subscription_group_get_groups: {
      tokens: [['text', '/subscription_group/groups']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_post_invitation_groups_mails: {
      tokens: [['text', '/lives/invitations/groups/mails']],
      defaults: [],
      requirements: {
        groups: 'array+',
        id: '\\d+',
        mails: 'array+',
      },
      hosttokens: [],
    },
    api_parameters_get_channels_group_by_themes: {
      tokens: [['variable', '/', '[^/]++', 'ids'], ['text', '/channel/channel-by-themes']],
      defaults: {
        ids: null,
      },
      requirements: [],
      hosttokens: [],
    },
    
      api_parameters_get_live_types: {
      tokens: [['variable', '/', '[^/]++', 'ids'], ['text', '/live/types']],
      defaults: {
        ids: null,
      },
      requirements: [],
      hosttokens: [],
    },

    
    api_subscription_user_get_users_by_group: {
      tokens: [
        [
          "variable",
          "/",
          "\d+",
          "id"
        ],
        [
          "text",
          "/subscription_user/users-by-id"
        ]
      ],
      defaults: [ ],
      requirements: {
        id: "\d+"
      },
      hosttokens: [ ]
    },
    api_post_live_revive: {
      tokens: [
        [
          "variable",
          "/",
          "\d+",
          "id"
        ],
        [
          "text",
          "/live/revive"
        ]
      ],
      defaults: [ ],
      requirements: {
        id: "\d+"
      },
      hosttokens: [ ]
    },
    api_download_live: {
      "tokens": [
        [
          "variable",
          "/",
          "\\d+",
          "id"
        ],
        [
          "text",
          "video-api/video/download"
        ]
      ],
      "defaults": [],
      "requirements": {
        "id": "\\d+"
      },
      "hosttokens": []
    },
    api_live_get_skins: {
      tokens: [['text', '/live/skin']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },

  },
  prefix: '',
  host: 'localhost',
  scheme: 'http',
};



// WEBPACK FOOTER //
// ./src/core/router/fos_js_routes_export.js